import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { EMPTY, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { OldAlertService } from '../services/old-alert.service';
import { HttpCancelService } from '../services/http-cancel.service';
import { LoadingService } from '../services/loading.service';
import { ToastrService } from 'ngx-toastr';

export const responseErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const alerts = inject(OldAlertService);
  const httpCancelService = inject(HttpCancelService);
  const loadingService = inject(LoadingService);
  const toastr = inject(ToastrService);

  loadingService.show();
  loadingService.increment();

  return next(req).pipe(
    catchError((errorResponse: any) => {
      const status = errorResponse?.status;
      const message =
        errorResponse?.error?.error ||
        errorResponse?.error?.message ||
        errorResponse?.statusText ||
        'Errore durante la richiesta';

      switch (true) {
        case status === 0 || status >= 500:
          if (req.url.includes('/resource')) {
            toastr.error(message, 'Documentale Error');
            return EMPTY;
          }
          alerts.showAlert('error', message);
          break;
        case status === 403:
          alerts.showAlert('error', message);
          break;
        case status >= 300 && status < 400:
          alerts.showAlert('warning', message);
          break;
        case status >= 400 && status < 500:
          alerts.showAlert('error', message);
          break;
        default:
          alerts.showAlert('error', message);
          break;
      }

      httpCancelService.cancelPendingRequests();
      loadingService.reset();
      return throwError(errorResponse);
    }),
    finalize(() => {
      loadingService.decrement();
      if (loadingService.totalRequests === 0) {
        loadingService.hide();
      }
    })
  );
};
